import { render, staticRenderFns } from "./ProductContentAssist.vue?vue&type=template&id=76009194"
import script from "./ProductContentAssist.vue?vue&type=script&lang=js"
export * from "./ProductContentAssist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports